import { AssetIcon, CountryCode, Currency } from '@shared/graphql'

/**
 * Type guard to check if a given token string is a valid asset icon.
 */
export const isAssetIcon = (token: string): token is AssetIcon =>
  Object.keys(AssetIcon).includes(token)

/**
 * Type guard to check if a given token or symbol string is a valid currency.
 */
export const isCurrency = (name?: string): name is Currency =>
  name ? Object.keys(Currency).includes(name) : false

/**
 * Type guard to check if country code is US or CA.
 */
export const isUsaOrCanada = (
  name?: CountryCode,
): name is CountryCode.US | CountryCode.CA =>
  name != null ? [CountryCode.US, CountryCode.CA].includes(name) : false

/**
 * Type guard to check if country code.
 */
export const isCountryCode = (code?: string): code is CountryCode =>
  code != null ? Object.keys(CountryCode).includes(code) : false

/**
 * Type guard to check if a country is EEA.
 */
export const isEeaCountry = (
  {
    countryOfIncorporation,
    primaryPlaceOfBusiness,
  }: {
    countryOfIncorporation: CountryCode
    primaryPlaceOfBusiness?: CountryCode
  },
  eeaCountryCodes: CountryCode[],
) => {
  // countryOfIncorporation (COI) as SG overrides the default rule
  if (countryOfIncorporation === CountryCode.SG) {
    return false
  }

  // Default rule: Either COI or primaryPlaceOfBusiness (PPOB) must be a EEA countries/territories
  return (
    eeaCountryCodes.includes(countryOfIncorporation) ||
    (primaryPlaceOfBusiness != null &&
      eeaCountryCodes.includes(primaryPlaceOfBusiness))
  )
}
